/**
 * Exposes build-time env values in the browser for debugging.
 * - In development (npm run dev): always set on window.__APP_ENV_DEBUG__
 * - In production build: only set when URL contains ?env_debug=1
 * Use in console: __APP_ENV_DEBUG__
 *
 * In DevTools Sources search, use:  __CXME_ENV__
 * The only match will show the inlined env (e.g. stage|app.stage...|api.stage...).
 */
const envDebug = (): void => {
    const isDev = import.meta.env.DEV;
    const showFromQuery =
        typeof window !== 'undefined' &&
        window.location.search.includes('env_debug=1');
    if (!isDev && !showFromQuery) return;

    const appEnv = import.meta.env.VITE_APP_ENV;
    const ssoOrigin = import.meta.env.VITE_SSO_APP_ORIGIN;
    const apiHost = import.meta.env.VITE_BOOMTOWN_API_HOST;
    // Single searchable string in the bundle: search DevTools for __CXME_ENV__
    const __CXME_ENV__ = `${appEnv ?? ''}|${ssoOrigin ?? ''}|${apiHost ?? ''}`;

    (window as unknown as { __APP_ENV_DEBUG__?: Record<string, string | undefined> }).__APP_ENV_DEBUG__ = {
        VITE_APP_ENV: appEnv,
        VITE_SSO_APP_ORIGIN: ssoOrigin,
        VITE_BOOMTOWN_API_HOST: apiHost,
        __CXME_ENV__, // one string to search for in Sources: shows "env|ssoOrigin|apiHost"
    };
};

envDebug();
